import { observer } from "mobx-react-lite";
import { appRoutes } from "@/app/router";
import { FC } from "react";
import { Navigate } from "react-router-dom";
import { usePublicAppStore } from "@/store";
import { AuthCardSignUp } from "@/components/auth/AuthCardSignUp";
import { AuthLayout } from "@/components/auth/layout/AuthLayout";

export const SignUpPage: FC = observer(() => {
  const { publicStore } = usePublicAppStore();

  if (publicStore.auth.isAuthenticated) {
    return <Navigate to={appRoutes.notesList({}).path} />;
  }

  return (
    <AuthLayout>
      <AuthCardSignUp />
    </AuthLayout>
  );
});
